import sharedAssets from "@/assets/shared";
import {
  isPhotonAppRoute,
  PHOTON_URL,
} from "@/components/Auth/shared/constants.auth";
import { useLocation } from "@/lib/router";
import { cn } from "@/utils/cn";
import { EXTERNAL_LINKS } from "../config.nav";

interface LogoProps {
  dark?: boolean;
  size?: "sm" | "md";
  onClick?: () => void;
  className?: string;
}

export const NavLogo: React.FC<LogoProps> = ({
  dark = false,
  size = "md",
  onClick,
  className,
}) => {
  const location = useLocation();
  const titleSrc = dark
    ? sharedAssets.aftershootTitleLight
    : sharedAssets.aftershootTitle;

  // Photon funnel context: swap the Aftershoot lockup for Photon's own,
  // linking out to getphoton.com instead of aftershoot.com.
  if (isPhotonAppRoute(location.pathname)) {
    return (
      <a
        href={PHOTON_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        className={cn("flex items-center justify-center", className)}
      >
        <img
          src={sharedAssets.photonLogoWhite}
          alt="Photon"
          className={cn(size === "sm" ? "h-5" : "h-6 sm:h-8")}
        />
      </a>
    );
  }

  return (
    <a
      href={EXTERNAL_LINKS.home}
      onClick={onClick}
      className={cn("flex items-center justify-center space-x-3", className)}
    >
      <img
        src={sharedAssets.aftershootLogo}
        alt="Logo Icon"
        className={cn(
          "shrink-0",
          size === "sm" ? "h-5 w-5" : "w-6 sm:h-12 sm:w-10",
        )}
      />
      <img
        src={titleSrc}
        alt="Logo"
        className={cn(size === "sm" ? "h-3 w-20" : "w-[74px] sm:h-5 sm:w-28")}
      />
    </a>
  );
};
